.allControlsDisabledContainer {
    margin: 10px;
}